import ZipCode from './ZipCode';

export default ZipCode;
